
import React from 'react';
import { Button } from "@/components/ui/button";
import { Link } from 'react-router-dom';
import { useIsMobile } from '@/hooks/use-mobile';

const Hero = () => {
  const isMobile = useIsMobile();
  
  return (
    <section className="relative bg-gradient-to-r from-piano-black to-gray-900 text-white py-20 lg:py-32 overflow-hidden">
      <div className="absolute inset-0 opacity-20 bg-pattern"></div>
      <div className="container mx-auto px-4 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div className="max-w-xl animate-fade-in">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-serif font-bold leading-tight mb-6">
              Bring musikken til live med <span className="text-piano-gold">professionel klaverundervisning</span>
            </h1>
            <p className="text-xl text-gray-300 mb-6 flex flex-col gap-1">
              <span>Klaverundervisning for alle niveauer med Oscar Gilbert - uddannet fra Rytmisk Musikkonservatorium.</span>
              <span>
                <span className="font-semibold">1# på Trustpilot i kategorierne </span>
                <a href="https://dk.trustpilot.com/categories/piano_instructor" target="_blank" rel="noopener noreferrer" className="text-piano-gold hover:underline">Klaverlærer</a> og <a href="https://dk.trustpilot.com/categories/music_instructor" target="_blank" rel="noopener noreferrer" className="text-piano-gold hover:underline">Musiklærer</a>.
              </span>
              <span>Undervisning i Søborg eller online.</span>
            </p>
            
            {/* Trustpilot Rating */}
            <div className="flex items-center mb-8 bg-white/10 p-4 rounded-lg backdrop-blur-sm">
              <div className="mr-4">
                <div className="text-4xl font-bold">4,9</div>
                <div className="text-sm text-gray-300">Fremragende</div>
              </div>
              <div className="flex">
                {[...Array(5)].map((_, i) => (
                  <svg key={i} className="w-6 h-6 text-[#00B67A]" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" />
                  </svg>
                ))}
              </div>
              <a 
                href="https://dk.trustpilot.com/review/oscargilbert.dk"
                target="_blank"
                rel="noopener noreferrer"
                className="text-xs text-gray-300 ml-2 hover:text-piano-gold whitespace-nowrap"
              >
                {isMobile ? "Trustpilot" : "Se anmeldelser på Trustpilot"}
              </a>
            </div>
            
            <div className="flex flex-col sm:flex-row gap-4">
              <Button asChild size="lg" className="bg-piano-gold hover:bg-piano-gold/90 text-white">
                <Link to="/kontakt">Gratis Prøvetime</Link>
              </Button>
              <Button asChild size="lg" variant="outline" className="bg-white border-white hover:bg-white/90 text-piano-black">
                <Link to="/undervisning">Se Undervisningstilbud</Link>
              </Button>
            </div>
          </div>
          <div className="relative hidden lg:block">
            <div className="w-full h-[500px] rounded-lg shadow-2xl overflow-hidden">
              <img 
                src="/lovable-uploads/645ce282-0307-4a13-a3a7-eb036180d6af.png" 
                alt="Oscar Gilbert ved klaveret" 
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
